import { Regions } from "./index.js";
function deepFreeze(obj) {
    for (const value of Object.values(obj)) {
        if (typeof value === "object" && value !== null) {
            Object.freeze(value);
        }
    }
    return Object.freeze(obj);
}
export const REGION_REGISTRY = deepFreeze({
    sg: {
        timezone: "Asia/Singapore",
        currency: "SGD",
        defaultOrgId: "ORG001",
        availableUnderwriters: ["qbe", "axa"],
        availableProductTypes: ["item", "travel"],
        availableItemClassifications: ["laptop", "camera", "jewellery", "watch", "handbag", "art", "wine", "whisky", "tradingCard"],
        collectorClassifications: ["art", "wine", "whisky", "tradingCard"],
        supportEmail: "singapore@support.kovernow.com",
    },
    hk: {
        timezone: "Asia/Hong_Kong",
        currency: "HKD",
        defaultOrgId: "ORG001",
        // "circles" = runoff (existing policies, no new sales); "axa" = new HK-AXA
        // purchase (WS1). No backend gate currently reads this list, but frontends
        // and future gates rely on it being correct.
        availableUnderwriters: ["circles", "axa"],
        availableProductTypes: ["item"],
        availableItemClassifications: ["watch", "jewellery", "handbag"],
        // Flag-gated (enable_collector_categories_hk, seeded OFF). Trading cards
        // added 2026-10-15 (HK$115,000 cap, SG review rules — see
        // underwriter_review_evaluator.ts); apps read this via GET /flags.
        collectorClassifications: ["art", "wine", "whisky", "tradingCard"],
        supportEmail: "hongkong@support.kovernow.com",
    },
});
function toRegionString(region) {
    const r = region;
    if (!Regions.includes(r)) {
        throw new Error(`Invalid region: ${r}`);
    }
    return r;
}
export function getRegionConfig(region) {
    return REGION_REGISTRY[toRegionString(region)];
}
export function getTimezone(region) {
    return getRegionConfig(region).timezone;
}
export function getCurrency(region) {
    return getRegionConfig(region).currency;
}
